import GenericCardStack from './images/GenericCardStack.svg';
import GoogleDriveCardStack from './images/GoogleDriveCardStack.svg';
import MicrosoftSuiteCardStack from './images/MicrosoftSuiteCardStack.svg';

// Products whose stack shows one logo per card, so each ships its own artwork.
const bespokeCardStacks: Record<string, string | undefined> = {
	drive: GoogleDriveCardStack,
	sharepoint: MicrosoftSuiteCardStack,
};

// Every other product uses the generic stack, with its own logo drawn on the front card.
export const getCardStackAsset = (appId: string): string =>
	bespokeCardStacks[appId] ?? GenericCardStack;

// A bespoke stack already carries its logos, so drawing `iconUrl` on the artwork would repeat them.
export const shouldDrawIconOnStack = (appId: string): boolean => !(appId in bespokeCardStacks);
